import { SigLabel } from '../components/atelier';

export function Pitch() {
  return (
    <section className="container section-tight">
      <div className="frame">
        <SigLabel>The honest pitch</SigLabel>
        <p className="frame-pull" style={{ marginTop: 24 }}>
          We don&rsquo;t replace <span className="mono" style={{ fontSize: '0.7em', letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--fg-muted)' }}>CATIA</span>.{' '}
          <em>We get you to the first draft, faster.</em> Then we ship a clean
          STEP into the pipeline you already trust.
        </p>
        <div
          style={{
            marginTop: 32,
            display: 'flex',
            gap: 24,
            flexWrap: 'wrap',
            color: 'var(--fg-muted)',
            fontSize: 13,
            lineHeight: 1.6,
            maxWidth: 760,
          }}
        >
          <p style={{ margin: 0 }}>
            CATIA, Creo, and SolidWorks are where serious mechanical work
            happens. We&rsquo;re not trying to displace any of them. Honestly,
            we couldn&rsquo;t.
          </p>
          <p style={{ margin: 0 }}>
            What we <em style={{ fontFamily: 'var(--font-serif)', color: 'var(--accent)' }}>can</em> do
            is cut the boring start. The first draft. The throwaway spike. The
            &ldquo;does this even fit?&rdquo; check. That&rsquo;s where LMcad
            lives. You sketch by talking, we hand you a STEP, you take it from
            there.
          </p>
        </div>
      </div>
    </section>
  );
}
